import { turboproApi } from '@/api/turbopro';
import type { AtualizaConfigRelatorioPayload } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function atualizaConfigRelatorioApi(
  payload: AtualizaConfigRelatorioPayload
): Promise<void> {
  await turboproApi<null>('Relatorios/AtualizaConfigRelatorio', {
    method: 'POST',
    body: payload,
    headers: getRelatoriosHeaders(),
  });
}
